/**
 * Event payment methods (pure: no Supabase import, so utils and tests can use it).
 *
 * Stored values. Only `cash` and `bank_transfer` are offered now: a QR payment is a bank transfer
 * (same account, same receipt line), and cheques are not accepted. `qr` / `check` stay in the type
 * so rows recorded earlier still display.
 */

export type EventPaymentMethod = 'cash' | 'bank_transfer' | 'qr' | 'check';

/** What the screens let you pick */
export const SELECTABLE_PAYMENT_METHODS: EventPaymentMethod[] = ['cash', 'bank_transfer'];

export const PAYMENT_METHOD_LABELS: Record<EventPaymentMethod, string> = {
  cash: 'Efectivo',
  bank_transfer: 'Transferencia / QR',
  qr: 'Transferencia / QR',
  check: 'Cheque',
};

/** Groups legacy `qr` rows with transfers (for totals and filters) */
export function normalizePaymentMethod(method: EventPaymentMethod | null | undefined): EventPaymentMethod | null {
  return method === 'qr' ? 'bank_transfer' : (method ?? null);
}
